module.exports = __webpack_public_path__ + "images/feature/data-export-2-559c4d3141a75ff312899da00014a08c.png";